<template>
  <div>
    <div class="row">
      <div class="col-md-6">
          <div class="create-user-form__section">
            <div class="create-user-form__section-title">
              {{ $t('labels.add_photo') }}
            </div>
            <avatar-editor
              @saved="onAvatarSaved"
              @deleted="onAvatarDeleted"
              ref="avatarEditor"
            ></avatar-editor>
          </div>
          <div class="create-user-form__section">
            <div class="create-user-form__section-title">
              {{ $t('labels.note') }}
            </div>
            <el-input v-model="userData.note"
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 10}"
                      :placeholder="$t('labels.note')">
            </el-input>
          </div>
          <div class="create-user-form__section">
            <div class="create-user-form__section-title">
              {{ $t('labels.communication_methods') }}
            </div>
            <div v-for="(contact, index) in userData.contacts" :key="index"
                 class="user-form-contact">
                 <div class="user-form-contact__row">
                    <el-input
                            v-bind:class="{ showLabel: userData.contacts[index].type }"
                            v-model="userData.contacts[index].type"
                            type="text"
                            :placeholder="$t('labels.title')">
                        <label slot="prefix">{{ $t('labels.title') }}</label>
                    </el-input>
                    <el-input
                            v-bind:class="{ showLabel: userData.contacts[index].value }"
                            v-model="userData.contacts[index].value"
                            type="text"
                            :placeholder="$t('labels.contacts')">
                        <label slot="prefix">{{ $t('labels.contact') }}</label>
                    </el-input>
                    <img class="user-form-contact__delete" @click="deleteContact(index)" :title="$t('labels.delete')"
                       src="static/img/icon_dropmenu_trash.svg"/>
                 </div>
            </div>
            <div class="user-form-contact__add">
              <span @click="addContact">
                {{ $t('labels.add') }}
              </span>
            </div>
          </div>
     </div>
  </div>
</div>
</template>
<script>
  import AvatarEditor from 'src/components/AvatarEditor/AvatarEditor.vue';
  import MaskedInput from 'vue-masked-input'

  export default {
    components: {
      AvatarEditor,
      MaskedInput
    },
    data () {
      return {
        userData: {
          note: '',
          contacts: [
            {
              type: this.$t('labels.email'),
              value: ''
            },
            {
              type: this.$t('labels.phone'),
              value: ''
            },
          ]
        },
        userpic: {
          blob: null,
          preview: null
        }
      };
    },
    methods: {
      onAvatarDeleted () {
        this.$refs.avatarEditor.reset()
        this.userpic.preview = null;
        this.userpic.blob = null;
      },
      onAvatarSaved (imageDataUrl, imageBlob) {
        this.userpic.preview = imageDataUrl;
        this.userpic.blob = imageBlob
      },
      addContact () {
        this.userData.contacts.push({type: '', value: ''})
      },
      deleteContact (index) {
        this.userData.contacts.splice(index, 1);
      },
      formReset () {
        this.userData = {
          note: '',
          contacts: [
            {
              type: this.$t('labels.email'),
              value: ''
            },
            {
              type: this.$t('labels.phone'),
              value: ''
            },
          ]
        }
        this.onAvatarDeleted();
      },
      getData () {
        let note = this.userData.note;
        let contacts = this.userData.contacts.filter(function(contact) {
          return contact.type && contact.value;
        });
        return {note, contacts}
      },
      isStepValid () {
        return true;
      }
    }
  }
</script>

<style lang="scss">
  .user-form-contact {
    position: relative;
    margin-bottom: 25px;

    .el-input {
      margin-bottom: 0 !important;
    }

    &__row {
      display: grid;
      grid-template-columns: .5fr 1fr 20px;
      grid-column-gap: 15px;
      align-items: center
    }

    &__add {
      color: #2196F3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196F3, 15%);
      }
    }

    &__delete {
      // position: absolute;
      // right: -20px;
      // top: 50%;
      cursor: pointer;
    }
  }
</style>